export const REPORT_CONFIG: any = {
    'internal-admin-qr-code-checkins-without-profiles': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: [],
        SEARCH_API: 'search/qr-code-checkins-without-profiles'
    },
};